import { useCallback } from "react";
import { LicensesApi, useAPIAction } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export interface TransferLicenseConfirmButtonInterface {
  existing_user_reference_id: string;
  new_user_reference_id: string;
  serial_number: string;
}

export const useTransferLicense = () => {
  const { t } = useTranslation();
  const [TransferLicense] = useAPIAction(
    LicensesApi,
    async (
      api,
      TransferLicenseActionDetails: TransferLicenseConfirmButtonInterface
    ) => {
      let data = await api.transferSerialNumber({
        controlcenterMelcoModelsTransferSerialNumber: {
          existing_user_reference_id:
            TransferLicenseActionDetails.existing_user_reference_id,
          new_user_reference_id:
            TransferLicenseActionDetails.new_user_reference_id,
          serial_number: TransferLicenseActionDetails.serial_number,
        },
      });

      // let batchNumber = data && data.list && data.list[0] ? (data.list[0]?.batch ?? "") : ""
      return {
        successMessages: [
          { message: t(`licenses.basic.detail.transfer.success.default`) },
        ],
        data,
      };
    },
    {
      //skipErrorHandling: true,
      translationPrefix: "",
    }
  );

  return useCallback(
    async (TransferActionDetails: TransferLicenseConfirmButtonInterface) => {
      return await TransferLicense(TransferActionDetails);
    },
    [TransferLicense]
  );
};
